import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './search-results.html';
import { DOCUMENT_LANGUAGE_LIST } from '../constants/DocumentLanguageList.constant';
var SearchResultsComponent = (function () {
    function SearchResultsComponent(coveoSearchService, translation) {
        this.coveoSearchService = coveoSearchService;
        this.translation = translation;
        this.interfaceLanguage = this.coveoSearchService.getInterfaceLanguage();
    }
    SearchResultsComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var searchInterface, executeFirstSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.coveoSearchService.setCoveoModulesUrls(this.coveoHeadlessModuleUrl, this.coveoIndexModuleUrl);
                        searchInterface = document.querySelector('#search-interface');
                        return [4, this.coveoSearchService.initSearchInterface(searchInterface, this.accessToken, this.organizationId)];
                    case 1:
                        _a.sent();
                        this.setCustomTranslations(searchInterface);
                        this.coveoSearchService.registerCustomComponents();
                        executeFirstSearch = true;
                        this.coveoSearchService.enableLanguageFiltering(executeFirstSearch);
                        this.coveoSearchService.enableAutomaticLanguageSelector();
                        if (!!this.noResultImageUrl) {
                            this.coveoSearchService.setCustomStyles(this.noResultImageUrl);
                        }
                        return [2];
                }
            });
        });
    };
    SearchResultsComponent.prototype.getTranslation = function (translationKey) {
        return this.translation.getSystem(translationKey);
    };
    SearchResultsComponent.prototype.setCustomTranslations = function (searchInterface) {
        this.setInterfaceTranslations(searchInterface);
        this.setFacetTranslations(searchInterface);
        this.setDocumentLanguageTranslations(searchInterface);
    };
    SearchResultsComponent.prototype.setInterfaceTranslations = function (searchInterface) {
        searchInterface.i18n.addResourceBundle(this.interfaceLanguage, 'translation', {
            filterByProductType: this.getTranslation("CoveoSearch_FilterByProductType"),
            filterByProductName: this.getTranslation("CoveoSearch_FilterByProductName"),
            contentType: this.getTranslation("CoveoSearch_ContentType"),
            documentLanguage: this.getTranslation("CoveoSearch_Language"),
            pairingGuide: this.getTranslation("CoveoSearch_PairingGuide"),
            buy: this.getTranslation("CoveoSearch_Buy"),
            serialNumberLocator: this.getTranslation("CoveoSearch_Facet_" + "Serial_Number_Locator"),
        });
    };
    SearchResultsComponent.prototype.setDocumentLanguageTranslations = function (searchInterface) {
        var documentLanguageTranslations = this.createTranslationObject(DOCUMENT_LANGUAGE_LIST, "Language_Title_");
        searchInterface.i18n.addResourceBundle(this.interfaceLanguage, 'caption-languagetitleen', documentLanguageTranslations);
    };
    SearchResultsComponent.prototype.setFacetTranslations = function (searchInterface) {
        var captionDocumentTypes = [
            "Document",
            "FAQ",
            "Firmware",
            "Hearing Protection",
            "Jabra Glossary",
            "Pairing Guide",
            "Product Catalog",
            "Product Support Page",
            "Release Notes",
            "Serial Number Locator",
            "Software",
            "Technical Whitepapers",
            "Warranty Terms",
            "YouTube Video"
        ];
        var captionProductTypes = [
            "Accessory", "Handset", "Hearing Aid", "Hearing Enhancement",
            "Software and services", "Speaker", "Speakerphone", "Video conferencing",
            "Wired headset", "Wireless headset"
        ];
        var documentTypeTranslations = this.createTranslationObject(captionDocumentTypes, "CoveoSearch_Facet_");
        var productTypeTranslations = this.createTranslationObject(captionProductTypes, "CoveoSearch_Facet_");
        searchInterface.i18n.addResourceBundle(this.interfaceLanguage, 'caption-documenttype', documentTypeTranslations);
        searchInterface.i18n.addResourceBundle(this.interfaceLanguage, 'caption-producttype', productTypeTranslations);
    };
    SearchResultsComponent.prototype.createTranslationObject = function (rawValues, prefix) {
        var _this = this;
        return rawValues.reduce(function (obj, title) {
            var key = "" + prefix + title.replace(/[(&),]/g, '').replace(/ /g, '_');
            var translation = _this.getTranslation(key);
            if (translation && translation !== '') {
                obj[title] = translation;
            }
            return obj;
        }, {});
    };
    SearchResultsComponent.$inject = [
        'coveoSearchService',
        'translation',
    ];
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SearchResultsComponent.prototype, "accessToken", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SearchResultsComponent.prototype, "organizationId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SearchResultsComponent.prototype, "searchInterfacePipeline", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SearchResultsComponent.prototype, "searchInterfaceSearchHub", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SearchResultsComponent.prototype, "coveoHeadlessModuleUrl", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SearchResultsComponent.prototype, "coveoIndexModuleUrl", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SearchResultsComponent.prototype, "noResultImageUrl", void 0);
    SearchResultsComponent = __decorate([
        Component({
            selector: 'searchResults',
            template: template,
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], SearchResultsComponent);
    return SearchResultsComponent;
}());
export { SearchResultsComponent };
